// Placement Grid client types — hand-mirrors apps/game/src/grid/types.ts
// (the worker is the source of truth; the share-format tests on each side
// catch constant drift). The client never computes the authoritative score:
// it displays what POST /grid/result returns, and only mirrors the curve for
// the optimistic pre-response render.

export const GRID_SIZE = 3;
export const DEAL_SIZE = 12;
export const TRAP_COUNT = 3;
export const GRID_PAR = 9;
export const GRID_SCORE_FLOOR = 2;

export type GridMode = 'easy' | 'hard';

/** Easy-mode score curve (mirror of the worker's scoreForMoves). */
export function scoreForMoves(moves: number): number {
  return Math.max(GRID_SCORE_FLOOR, Math.min(GRID_PAR, 2 * GRID_PAR - moves));
}

export interface TraitRef {
  id: string;
  label: string;
  dim: string; // header sub-label, e.g. 'drivetrain'
}

export interface GridCarView {
  id: string;
  label: string;
  year: number;
  fits: { rows: boolean[]; cols: boolean[] };
  cars_slug?: string;
}

export interface TrapNote {
  id: string;
  label: string;
  note: string;
}

/** The redacted puzzle served by GET /grid/:date — no answers, no trap marks. */
export interface GridClientPuzzle {
  v: 2;
  id: string;
  number: number;
  date: string;
  /** Monthly-special global filters (1–2, ANDed) — every dealt car satisfies all. */
  filters?: TraitRef[];
  rows: TraitRef[];
  cols: TraitRef[];
  cars: GridCarView[];
}

export type GridMove = { m: 'p'; car: string; cell: number } | { m: 'r'; cell: number };

export interface GridResultView {
  mode: GridMode;
  moves: number;
  faults: number;
  score: number;
  solved: boolean;
  movesLog: GridMove[];
  traps: TrapNote[];
}

export interface GridBoardResponse {
  puzzle: GridClientPuzzle;
  date: string;
  result: GridResultView | null;
}

/** Does this dealt car satisfy cell (row*3+col)? */
export function carFitsCell(car: GridCarView, cell: number): boolean {
  return car.fits.rows[Math.floor(cell / GRID_SIZE)] && car.fits.cols[cell % GRID_SIZE];
}
